import { imageFieldsFrag } from '@/service/fragments/imageFieldsFrag'
import type { ResultOf } from 'gql.tada'
import { graphql } from '@/service/graphql'
import { playableEntityFrag } from '@/service/fragments/playableEntityFrag'
import { playParamsFrag } from '@/service/fragments/playParamsFrag'
import { trackLikesContextFrag } from '@/track/trackLikeService'

// TODO: shortTitle is not allowed for anon
// https://t.corp.amazon.com/P258893146

// language=GraphQL
export const trackFieldsFrag = graphql(
    `
        fragment trackFields on Track @_unmask {
            ...playableEntity
            id
            contributingArtists {
                concatenatedName
                edges {
                    node {
                        id
                        name
                    }
                }
            }
            title
            ...trackLikesContext
            parentalSettings {
                hasExplicitLanguage
            }
            album {
                id
                title
                shortTitle @include(if: $isAuthenticated)
                playParams {
                    ...playParams
                }
            }
            duration
            images {
                ...imageFields
            }
        }
    `,
    [imageFieldsFrag, playableEntityFrag, playParamsFrag, trackLikesContextFrag]
)

export type TrackFields = ResultOf<typeof trackFieldsFrag>
